import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChangePasswordModalComponent } from './change-password-modal/change-password-modal.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OfferDetailsComponent } from './offer-details/offer-details.component';
import { CardModule } from '../content/partials/general/card/card.module';
import { BreadcrumbModule } from '../_layout/breadcrumb/breadcrumb.module';
import { BlockUIModule } from 'ng-block-ui';
import { BlockTemplateComponent } from '../_layout/blockui/block-template.component';
import { ConfirmationModalComponent } from './confirmation-modal/confirmation-modal.component';
import { ConfirmationDeleteModalComponent } from './confirmation-delete-modal/confirmation-delete-modal.component';

@NgModule({
  declarations: [
    ChangePasswordModalComponent,
    OfferDetailsComponent,
    ConfirmationModalComponent,
    ConfirmationDeleteModalComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    CardModule,
    BreadcrumbModule,
    ReactiveFormsModule,
    BlockUIModule.forRoot({
      template: BlockTemplateComponent
    }),
  ],
  exports:[
    ChangePasswordModalComponent,
    OfferDetailsComponent,
    ConfirmationModalComponent,
    ConfirmationDeleteModalComponent,
  ]
})
export class SharedComponentsModule { }
